<template>
  <div class="flow-conditions">
    <div class="flow-conditions__wrapper" @scroll="onScroll">
      <h5 class="flow-conditions__heading">{{ heading }}</h5>
      <ol class="flow-conditions__list">
        <li class="flow-conditions__item" v-for="(condition, index) of conditions" :key="index">
          <span class="flow-conditions__tip">{{ condition.title }}</span>
          <span class="flow-conditions__description">
            {{ condition.text }}
          </span>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'flow-conditions',
  data() {
    return {
      conditions: [
        {
          title: 'I have permission to email these people.',
          text:
            'Building a quality email list takes time, patience, and a verifiable opt-in process. Getting people’s permission to send them marketing emails not only complies with anti-spam regulations (violating these can result in steep fines for your business), but it’s good for your brand and helps you avoid damaging your domain reputation.',
        },
        {
          title: 'This is not a third party list.',
          text: `Third-party lists of email addresses are prohibited from use with ${this.platformTitle}. This includes purchased or rented lists, and lists scraped from third-party sources including public websites. Any contacts you add to ${this.platformTitle} must have been collected entirely by you. While purchasing a list is not technically illegal, most reputable email service providers prohibit sending to purchased lists.`,
        },
        {
          title: 'Uploading a “junk” list has consequences.',
          text: `If you upload and send to a list with a high number of undeliverable email addresses or spam reports, your domain reputation could be severely damaged and your ${this.platformTitle} account may be temporarily or permanently suspended. Not trying to be mean here. We just want you to be the best marketer you can be. I have read and agree to the above terms.`,
        },
      ],
      readingFinished: false,
    };
  },
  props: {
    heading: {
      type: String,
    },
    platformTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    onScroll(e) {
      if (e.target.scrollTop + e.target.clientHeight + 1 >= e.target.scrollHeight) {
        this.$emit('read');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.flow-conditions {
  text-align: left;
  background: $white-color;
  padding: 24px 8px 24px 24px;
  border: 1px solid $platinum-color;
  border-radius: 4px;
  margin-bottom: 30px;

  &__wrapper {
    max-height: 218px;
    overflow-y: scroll;
    padding-right: 12px;
    &::-webkit-scrollbar {
      -webkit-appearance: none;
    }

    &::-webkit-scrollbar:vertical {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #e0e0e0;
      border: none;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 8px;
    }
  }

  &__heading {
    color: $mine-shaft-color;
    font-size: 16px;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  &__list {
    list-style: decimal outside none;
    margin-left: 20px;
    font-size: 14px;
    line-height: 22px;
  }
  &__item {
    padding-left: 10px;
    margin-bottom: 20px;
  }
  &__tip {
    display: block;
    color: $mine-shaft-color;
  }
  &__description {
    color: $dove-grey-color;
  }
}
</style>
